import {createSelector} from 'reselect';
import props from '../props';
import {getWelcomeBonus} from '../../utils/user';

export default createSelector(
    props.user.isAuth,
    props.user.welcome_bonus,
    (isAuth, welcome_bonus) => {
        // Guest
        if(!isAuth) {
            const bonus = getWelcomeBonus();

            return {
                ...bonus,
                available: true
            }
        }

        return {
            deposit: welcome_bonus.deposit_bonus || 0,
            freeplay: welcome_bonus.freeplay || 0,
            available: welcome_bonus.status < 2
        }
    }
)